module.exports = __webpack_public_path__ + "media/armorUp.4b7d3f6c.mp3";